import React from "react";
import "./Footer.css";
import logo from "./blue_logo.png";

export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <img className="footer-logo" src={logo} alt="H.Enesta" />
        <div className="footer-copy">
          © {new Date().getFullYear()} H.Enesta. All rights reserved.
        </div>
      </div>
    </footer>
  );
}
